import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#28a054",
        secondary: "#fefefe",
        accent: "#b93342",
        error: "#fefee0",
        info: "#b9e3cc",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  }
});
